import type { ReactNode } from 'react';

import Logo from '../Logo/Logo';

import { Container } from './PublicTopbar.styled';

type PublicTopbarProps = {
  href?: string;
  children?: ReactNode;
};

export default function PublicTopbar({
  href = '/',
  children,
}: PublicTopbarProps) {
  return (
    <Container>
      <Logo href={href} />
      {children}
    </Container>
  );
}
